// Determine if authentication is required based on environment variable
// If REACT_APP_DISABLE_AUTH=true, auth is disabled (requiresAuth = false)
// If REACT_APP_DISABLE_AUTH=false or not set, auth is enabled (requiresAuth = true)
const requiresAuth = process.env.REACT_APP_DISABLE_AUTH !== 'true';

const routes = [
	{
		title: 'Get a quote', // 1
		path: '/',
		componentPath: './features/site/pages/get-quote/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Get a quote', // 1
		path: '/get-quote',
		componentPath: './features/site/pages/get-quote/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Select premium', //2
		path: '/get-quote/select-premium',
		componentPath: './features/site/pages/select-premium/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Animal Details', //3
		path: '/get-quote/animals',
		componentPath: './features/site/pages/animal-details/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Policy holder details', //4
		path: '/get-quote/policy-holder',
		componentPath: './features/site/pages/policy-holder-details/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Preview', //5
		path: '/get-quote/preview',
		componentPath: './features/site/pages/preview/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Quote Price', //6
		path: '/get-quote/price',
		componentPath: './features/site/pages/price/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Quote Details', //7
		path: '/get-quote/quoteDetails',
		componentPath: './features/site/pages/quoteDetails/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Quote Details', //8
		path: '/retrieve-quote/quoteDetails',
		componentPath: './features/site/pages/quoteDetails/',
		requiresAuth: requiresAuth,
	},
	{
		title: 'Retrieve quote', //9
		path: '/retrieve-quote',
		componentPath: './features/site/pages/retrieve-quote/',
		requiresAuth: requiresAuth,
	},
];

export default routes;
